import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, Typography, Box, IconButton 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { uploadLCScores } from '../../../services/mentorServices/LearnerPracticeServices';

const UploadCsvModal = ({ open, onClose, onUploadSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleDownloadSample = () => {
        try {
            const fileUrl = `${process.env.PUBLIC_URL}/Sample_Learner_LC_Parameter.csv`;
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = "Sample_Learner_LC_Parameter.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success("Sample CSV downloaded successfully!");
        } catch (error) {
            console.error("Error downloading sample file:", error);
            toast.error("Failed to download the sample file.");
        }
    };

    const handleUpload = async () => {
        if (selectedFile) {
            try {
                const formData = new FormData();
                formData.append('file', selectedFile);

                const response = await uploadLCScores(formData);
                if (response?.data?.success) {
                    toast.success(response?.data?.message || "File uploaded successfully!");
                    setSelectedFile(null);
                    if (onUploadSuccess) onUploadSuccess();
                    onClose();
                } else {
                    toast.error(response?.data?.message || "Failed to upload file.");
                }
            } catch (error) {
                console.error("Error uploading file:", error);
                toast.error(error?.response?.data?.error?.message || error?.message ||error?.response?.message ||  "An error occurred while uploading.");
            }
        } else {
            toast.error("Please select a file to upload.");
        }
    };

    const handleClose = () => {
        setSelectedFile(null);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '8px' } }}>
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 700, color: '#495057' }}>
                    Upload Learner Reviews CSV
                </Typography>
                <IconButton onClick={handleClose} sx={{ color: '#9e9e9e' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <Button 
                        startIcon={<FileDownloadIcon />} 
                        onClick={handleDownloadSample}
                        sx={{ textTransform: 'none', fontWeight: 600, color: '#1976d2' }}
                    >
                        Download Sample CSV
                    </Button>
                </Box>
                
                <Box sx={{ 
                    border: '2px dashed #ced4da', 
                    borderRadius: '8px', 
                    padding: '40px 20px', 
                    textAlign: 'center',
                    backgroundColor: '#f8f9fa',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px'
                }}>
                    <CloudUploadIcon sx={{ fontSize: '48px', color: '#adb5bd' }} />
                    <Typography sx={{ color: '#495057', fontWeight: 600, fontSize: '15px' }}>
                        Drag & Drop your CSV file here
                    </Typography>
                    <Typography sx={{ color: '#6c757d', fontSize: '13px', mb: 1 }}>
                        or
                    </Typography>
                    <Button 
                        variant="outlined" 
                        component="label"
                        sx={{ textTransform: 'none', borderRadius: '6px', fontWeight: 600 }}
                    >
                        Browse Files
                        <input 
                            type="file" 
                            hidden 
                            accept=".csv"
                            onChange={handleFileChange}
                        />
                    </Button>
                    
                    {selectedFile && (
                        <Typography sx={{ mt: 2, color: '#1976d2', fontWeight: 600, fontSize: '14px', wordBreak: 'break-all' }}>
                            Selected file: {selectedFile.name}
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: '16px 24px', borderTop: '1px solid #e0e0e0', backgroundColor: '#f8f9fa' }}>
                <Button onClick={handleClose} sx={{ textTransform: 'none', fontWeight: 600, color: '#6c757d' }}>
                    Cancel
                </Button>
                <Button 
                    onClick={handleUpload} 
                    variant="contained" 
                    disabled={!selectedFile}
                    sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '4px', boxShadow: 'none' }}
                >
                    Upload CSV
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadCsvModal;
